import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
export function HudSlots({ className, children }) {
    return _jsx(HudSlotsRoot, { className: className, children: children });
}
export const Slot = styled.div `
    display: flex;
    align-items: center;
    gap: 0.75rem;
    position: absolute;

    &:empty {
        display: none;
    }

    & > * {
        pointer-events: auto;
    }
`;
export const TopLeftSlot = styled(Slot) `
    top: var(--tv-HudSlots-offset, 1.5rem);
    left: var(--tv-HudSlots-offset, 1.5rem);
`;
export const TopRightSlot = styled(Slot) `
    top: var(--tv-HudSlots-offset, 1.5rem);
    right: var(--tv-HudSlots-offset, 1.5rem);
`;
export const BottomRightSlot = styled(Slot) `
    --tv-HudBottomSlot-offset: var(--tv-HudSlots-offset, 1.5rem);
    bottom: var(--tv-HudBottomSlot-offset);
    right: var(--tv-HudSlots-offset, 1.5rem);
`;
export const BottomLeftSlot = styled(Slot) `
    --tv-HudBottomSlot-offset: var(--tv-HudSlots-offset, 1.5rem);
    bottom: var(--tv-HudBottomSlot-offset);
    left: var(--tv-HudSlots-offset, 1.5rem);
`;
const HudSlotsRoot = styled.div `
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
`;
